<template>
  <div v-wechat-title="titleTop">
    <NativeBarDive ref="menu" v-model="NativeBarId" />
    <fullError title="暂未开放" about="水下基地正在施工中,敬请期待" native-str="" background-color="#f5f5f5" />
  </div>
</template>
<script>
// import request from '@/utils/request'
import { Button } from 'vant'
import { ShowMoney, GetEnumText, formatDate, getUserBase } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import NativeBarDive from '@/components/NativeBarDive'
import fullError from '@/components/fullError'
export default {
  components: {
    [Button.name]: Button,
    NativeBarDive,
    fullError
  },
  data() {
    return {
      titleTop: '',
      NativeBarId: 3
    }
  },
  activated() {
    this.NativeBarId = 3
  },
  created() {
    getUserBase(data => {
      this.titleTop = GetSysTitle()
    })
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate
  }
}
</script>
